module.exports = __webpack_public_path__ + "img/icon.fe8eb2da.png";